import { render, staticRenderFns } from "./collocationSetMeal.vue?vue&type=template&id=5e4c5710&scoped=true&"
import script from "./collocationSetMeal.vue?vue&type=script&lang=js&"
export * from "./collocationSetMeal.vue?vue&type=script&lang=js&"
import style0 from "./collocationSetMeal.vue?vue&type=style&index=0&id=5e4c5710&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c5710",
  null
  
)

export default component.exports